import { useLang } from "@/lib/i18n";

const PILLAR_META = [
  { icon: "fa-compass-drafting", color: "#D946EF" },
  { icon: "fa-code", color: "#0EA5E9" },
  { icon: "fa-credit-card", color: "#D62828" },
  { icon: "fa-bolt", color: "#65A30D" },
];

export default function About() {
  const { t } = useLang();
  const pillars = t("about.pillars").map((p, i) => ({ ...p, ...PILLAR_META[i] }));

  return (
    <section id="services" data-testid="about-section" className="py-24 lg:py-32 relative">
      <div className="max-w-[1320px] mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          <div className="lg:col-span-5">
            <span className="pill"><i className="fa-solid fa-asterisk text-[hsl(var(--accent))]" /> {t("about.pill")}</span>
            <h2 className="mt-5 font-display font-semibold text-4xl sm:text-5xl lg:text-[64px] leading-[1.0] tracking-tight">
              {t("about.titleLead")}
              <em className="italic font-light">{t("about.titleEm")}</em>
              {t("about.titleMid")}
              <br />
              <span className="text-[hsl(var(--accent))]">{t("about.titleHighlight")}</span>
            </h2>
            <p className="mt-7 text-[17px] leading-[1.6] text-[hsl(var(--ink-soft))] max-w-md">
              {t("about.paragraph")}
            </p>

            <div className="mt-9 grid grid-cols-2 gap-4 max-w-md">
              <div className="soft-card p-5">
                <div className="font-mono text-[10px] uppercase tracking-[0.18em] text-[hsl(var(--muted-foreground))]">
                  {t("about.hqLabel")}
                </div>
                <div className="mt-2 font-display text-xl font-semibold">{t("about.hqValue")}</div>
                <div className="text-xs text-[hsl(var(--ink-soft))] mt-0.5">{t("about.hqHint")}</div>
              </div>
              <div className="soft-card p-5">
                <div className="font-mono text-[10px] uppercase tracking-[0.18em] text-[hsl(var(--muted-foreground))]">
                  {t("about.opLabel")}
                </div>
                <div className="mt-2 font-display text-xl font-semibold">{t("about.opValue")}</div>
                <div className="text-xs text-[hsl(var(--ink-soft))] mt-0.5">{t("about.opHint")}</div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-5">
            {pillars.map((p, i) => (
              <div
                key={p.title}
                data-testid={`pillar-${i}`}
                className="soft-card p-7 fade-up"
                style={{ animationDelay: `${i * 70}ms` }}
              >
                <div
                  className="w-12 h-12 rounded-xl flex items-center justify-center mb-5"
                  style={{ background: `${p.color}1a`, color: p.color }}
                >
                  <i className={`fa-solid ${p.icon} text-lg`} />
                </div>
                <div className="font-display text-xl font-semibold tracking-tight">{p.title}</div>
                <p className="mt-2.5 text-sm text-[hsl(var(--ink-soft))] leading-relaxed">{p.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
